import _export from "../internals/export";
import _arrayIterationFromLast from "../internals/array-iteration-from-last";
import _addToUnscopables from "../internals/add-to-unscopables";
var $ = _export;
var $findLast = _arrayIterationFromLast.findLast;
var addToUnscopables = _addToUnscopables;

// `Array.prototype.findLast` method
// https://tc39.es/ecma262/#sec-array.prototype.findlast
$({
  target: "Array",
  proto: true
}, {
  findLast: function findLast(callbackfn /* , that = undefined */) {
    return $findLast(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
addToUnscopables("findLast");
export default {};